import { createFileRoute } from '@tanstack/react-router';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { OperationCreate } from '../../features/operations/operation-create';

export const Route = createFileRoute('/operations/new')({
  staticData: {
    permissionLevel: 'write',
    breadcrumb: 'New operation',
    layout: 'default',
  },
  component: OperationCreatePage,
});

function OperationCreatePage() {
  const partnerId = usePartnerId();

  return <OperationCreate partnerId={partnerId} />;
}
